function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from 'react';
/**
 * 미디어 모달 커스텀 훅
 * 
 * 미디어 갤러리에서 사용되는 모달 관련 기능을 제공합니다.
 * 
 * @param allMediaLength 전체 미디어 개수
 * @param options 모달 옵션
 * @returns 미디어 모달 관련 상태와 메서드
 */ export function useMediaModal(allMediaLength, options) {
    // 모달 상태 관리
    var _useState = _sliced_to_array(useState(false), 2), isModalOpen = _useState[0], setIsModalOpen = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), activeModalIndex = _useState1[0], setActiveModalIndex = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), hoveredIndex = _useState2[0], setHoveredIndex = _useState2[1];
    // 모달 열기/닫기 시 body 스크롤 제어
    useEffect(function() {
        if (isModalOpen) {
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
            // 옵션에 콜백이 있으면 호출
            if (options === null || options === void 0 ? void 0 : options.onModalStateChange) {
                options.onModalStateChange(true);
            }
        } else {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            // 옵션에 콜백이 있으면 호출
            if (options === null || options === void 0 ? void 0 : options.onModalStateChange) {
                options.onModalStateChange(false);
            }
        }
        return function() {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
        };
    }, [
        isModalOpen,
        options
    ]);
    // ESC 키로 모달 닫기
    useEffect(function() {
        var handleEscKey = function(e) {
            if (e.key === 'Escape' && isModalOpen) {
                closeModal();
            }
        };
        window.addEventListener('keydown', handleEscKey);
        return function() {
            window.removeEventListener('keydown', handleEscKey);
        };
    }, [
        isModalOpen
    ]);
    // 모달 포털을 위한 DOM 요소 생성 함수
    var createPortalRoot = function() {
        var portalRoot = document.getElementById('modal-portal-root');
        if (portalRoot) return portalRoot;
        var newPortalRoot = document.createElement('div');
        newPortalRoot.id = 'modal-portal-root';
        newPortalRoot.style.position = 'fixed';
        newPortalRoot.style.zIndex = '99999'; // 매우 높은 z-index 값
        newPortalRoot.style.top = '0';
        newPortalRoot.style.left = '0';
        newPortalRoot.style.width = '100vw';
        newPortalRoot.style.height = '100vh';
        newPortalRoot.style.pointerEvents = 'none'; // 기본적으로 포인터 이벤트 무시
        document.body.appendChild(newPortalRoot);
        return newPortalRoot;
    };
    // 컴포넌트 마운트 시 포털 루트 생성
    useEffect(function() {
        createPortalRoot();
        return function() {
            var portalRoot = document.getElementById('modal-portal-root');
            if (portalRoot && portalRoot.childNodes.length === 0) {
                document.body.removeChild(portalRoot);
            }
        };
    }, []);
    // 모달 열기 함수
    var openModal = function(index) {
        setActiveModalIndex(index);
        setIsModalOpen(true);
    };
    // 모달 닫기 함수
    var closeModal = function(e) {
        if (e) e.stopPropagation();
        setIsModalOpen(false);
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
    };
    // 이전 이미지 이동
    var handlePrevImage = function(e) {
        e.stopPropagation();
        setActiveModalIndex(function(prevIndex) {
            return prevIndex === 0 ? allMediaLength - 1 : prevIndex - 1;
        });
    };
    // 다음 이미지 이동
    var handleNextImage = function(e) {
        e.stopPropagation();
        setActiveModalIndex(function(prevIndex) {
            return prevIndex === allMediaLength - 1 ? 0 : prevIndex + 1;
        });
    };
    return {
        isModalOpen: isModalOpen,
        activeModalIndex: activeModalIndex,
        hoveredIndex: hoveredIndex,
        openModal: openModal,
        closeModal: closeModal,
        handlePrevImage: handlePrevImage,
        handleNextImage: handleNextImage,
        setHoveredIndex: setHoveredIndex,
        createPortalRoot: createPortalRoot
    };
}
export default useMediaModal;
